import { Link } from "react-router-dom";
import { EpRight } from "../../../components/study-abroad-landing/AboutEducationMentorsGlobally";
import LeadGenCtaBtn from "../../../features/lead-generation/LeadGenCtaBtn";

const Advertisment = () => {
  return (
    <>
      <div className="w-full flex  justify-center my-6 bg-blue p-5">
        <div className="w-full flex flex-col md:flex-row items-center gap-4">
          <div className="flex items-center justify-center md:w-3/4 text-white flex-col gap-3">
            <h4 className="text-lg font-bold">Admission Open for 2025</h4>
            <p className="w-full md:max-w-[647px] text-center">
              Secure your Scholarship Admission at your preferred college,
              Limited Seats Available Take the first step Now
            </p>
          </div>
          <div className="flex item-center justify-center md:w-1/4">
           <LeadGenCtaBtn
                  pageName="college-predictor-detail"
                  ctaName="predictor"
                  className="flex items-center bg-green px-4 py-2.5 text-white text-base text-center rounded-full gap-1"
                >
                  <span> Apply Now </span>
                </LeadGenCtaBtn>
            {/* <Link
              to="/college"
              
            >
              Apply Now <EpRight />
            </Link> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Advertisment;
